import styled from 'styled-components';
import { getSafeAreaValue } from '../../../../styled/theme/helpers/getSafeAreaValue';

export const Content = styled.div`
  padding: 20px 15px ${({ theme }) => getSafeAreaValue(theme, 'bottom', 20)};
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: #2f1f19;
  padding: 20px 0;
  border-bottom: 1px solid #eae5e1;
  position: relative;
`;

export const CloseBtn = styled.span`
  position: absolute;
  top: 15px;
  right: 15px;
  padding: 6px 5px 4px;
  font-size: 32px;
  line-height: 19px;
  font-weight: 400;
  color: #98918a;
  text-decoration: none;
  cursor: pointer;
  user-select: none;
`;

export const Name = styled.div`
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #2f1f19;
  margin-bottom: 10px;
`;

export const Price = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #2f1f19;
  display: flex;
  margin-bottom: 10px;

  .price-cur {
    margin: 0 5px;
  }
`;

export const PricePerMeter = styled.div`
  margin-left: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #98918a;
`;

export const Description = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #2f1f19;
  margin-bottom: 10px;

  span:not(:first-of-type)::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    background: #eae5e1;
    border-radius: 50%;
    margin: 0 5px;
    position: relative;
    bottom: 2px;
  }
`;

export const GalleryImg = styled.div`
  img {
    width: 345px;
    height: 245px;
    border: 1px solid #eae5e1;
    border-radius: 7px;
    margin: 0 auto;
    display: block;
    object-fit: contain;
  }
`;

export const GalleryThumbnails = styled.div`
  img {
    width: 112px;
    height: 63px;
    object-fit: contain;
  }

  .slick-current img {
    border: 1px solid #4264fd;
  }
`;
